import React from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  CircularProgress,
  Modal,
  Slide,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ListIcon from "@mui/icons-material/List";
import LineLogsDetails from "../../Lines/LineLogsDetails";

function GeneralInformationLogsModal(props) {
  const {
    open,
    onClose,
    translate,
    loading,
    logs,
    formatDateLogs2,
    circularProgressStyle,
    creatorName,
    dateOfCreation,
  } = props;

  if (!open) {
    return null;
  }

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="activity-log-title"
      aria-describedby="activity-log-description"
      closeAfterTransition
    >
      <Slide direction="left" in={open}>
        <Box
          sx={{
            position: "fixed",
            top: "5%",
            right: 0,
            width: "30%",
            height: "90%",
            bgcolor: "background.paper",
            boxShadow: 24,
            marginRight: "15px",
            pl: 0,
            pr: 0,
            borderRadius: "15px",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 1,
              borderBottom: "1px solid lightgray",
            }}
          >
            <div
              id="activity-log-title"
              style={{
                margin: 0,
                paddingLeft: "35px",
                paddingTop: "20px",
                paddingBottom: "10px",
                fontSize: "22px",
                fontWeight: "700",
              }}
            >
              {translate("ActivityLogs")}
            </div>
            <div style={{ paddingRight: "25px" }}>
              <Button onClick={onClose} variant="outlined">
                {translate("Close")}
              </Button>
            </div>
          </Box>
          <Box
            id="activity-log-description"
            sx={{
              flexGrow: 1,
              overflowY: "auto",
              mt: 1,
              pl: 4,
              pr: 3.3,
            }}
          >
            {loading ? (
              <div style={circularProgressStyle}>
                <CircularProgress />
              </div>
            ) : logs.length === 0 ? (
              <div style={{ padding: "20px", textAlign: "center" }}>
                No recent activity
              </div>
            ) : (
              logs
                .sort((a, b) => b.recordedAt.toDate() - a.recordedAt.toDate())
                .map((log) => (
                  <Accordion key={log.id}>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls={`panel-${log.id}-content`}
                      id={`panel-${log.id}-header`}
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        width: "100%",
                        padding: "5px 10px",
                        backgroundColor: "#f2f2f2",
                        borderBottom: "1px solid #e0e0e0",
                        fontFamily: '"Courier New", Consolas, monospace',
                        fontSize: "0.9em",
                        color: "#1d1d1d",
                        textTransform: "uppercase",
                      }}
                    >
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <ListIcon
                          style={{ marginRight: "8px", color: "#888888" }}
                        />
                        <div>
                          {log.recordedBy} - {formatDateLogs2(log.recordedAt)}
                        </div>
                      </div>
                    </AccordionSummary>
                    <AccordionDetails
                      style={{
                        marginTop: 0,
                        paddingTop: 0,
                        marginLeft: 0,
                        marginRight: 0,
                      }}
                    >
                      {Object.entries(log.changes)
                        .filter(([key]) => key !== "lastModification")
                        .map(([key, value]) => (
                          <LineLogsDetails key={key} fieldName={key} value={value} />
                        ))}
                    </AccordionDetails>
                  </Accordion>
                ))
            )}
            {creatorName && dateOfCreation && (
              <div
                style={{
                  fontSize: "12px",
                  fontStyle: "italic",
                  padding: "20px",
                  borderTop: "1px solid #e0e0e0",
                }}
              >
                {`Client added by ${creatorName} on ${dateOfCreation
                  .toDate()
                  .toLocaleString("en-US", {
                    year: "numeric",
                    month: "long",
                    day: "numeric",
                    hour: "2-digit",
                    minute: "2-digit",
                    second: "2-digit",
                  })}`}
              </div>
            )}
          </Box>
        </Box>
      </Slide>
    </Modal>
  );
}

export default GeneralInformationLogsModal;
